module.exports = __webpack_public_path__ + "img/avo-logo.c4b3b885.png";